<template>
  <div class="container-custom">
    <div class="main-wrapper">
      <section
        class="left-section"
        v-if="sectionsEnable.login || sectionsEnable.requestRecoveryPassword"
      >
        <div class="content-left-section">
          <div class="content-logo">
            <div class="fist-logo"></div>
          </div>

          <div class="text-content-left">
            <p class="title-left-section">
              Gestão agronômica com mais controle, agilidade e segurança
            </p>

            <p class="subtitle-left-section">
              Tecnologia completa para emissão de receituário agronômico,
              emissão fiscal e gestão da sua Revenda Agrícola. Tudo em um único
              sistema!
            </p>
          </div>

          <div class="beneficios">
            <div class="beneficio">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <ellipse cx="12" cy="5" rx="7" ry="3"></ellipse>
                <path d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5"></path>
                <path d="M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"></path>
              </svg>
              <span>Maior banco de dados de agrotóxicos do Brasil</span>
            </div>

            <div class="beneficio">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <circle cx="12" cy="14" r="4"></circle>
                <path d="M8 3l2 5"></path>
                <path d="M16 3l-2 5"></path>
                <path d="M10 18l-2.5 3"></path>
                <path d="M14 18l2.5 3"></path>
              </svg>
              <span>30 anos de mercado e experiência</span>
            </div>

            <div class="beneficio">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <circle cx="12" cy="12" r="3.5"></circle>
                <path
                  d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 1 1-4 0v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 1 1 0-4h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V4a2 2 0 1 1 4 0v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6h.2a2 2 0 1 1 0 4h-.2a1 1 0 0 0-.9.6z"
                ></path>
              </svg>
              <span>Receituário e emissão fiscal em um único processo</span>
            </div>
          </div>
        </div>
      </section>

      <section
        class="right-section"
        v-if="sectionsEnable.login || sectionsEnable.requestRecoveryPassword"
      >
        <div class="forms-containe">
          <div class="signin-signup">
            <form
              v-if="sectionsEnable.login"
              action="#"
              class="sign-in-form"
              @submit.prevent
            >
              <div class="right-logo">
                <div class="content-logo">
                  <div class="fist-logo"></div>
                </div>
              </div>

              <div class="content-titles">
                <p class="title-right-section">Acesse sua conta</p>
                <p class="subtitle-right-section">
                  Entre com seus dados para continuar no<br />
                  WINFIT Agro+
                </p>
              </div>

              <div class="body-inputs">
                <div class="input-wrapper">
                  <label for="" class="lb-email">E-mail</label>
                  <div class="input-field">
                    <i><b-icon-envelope-fill font-scale="1.3" /></i>
                    <input
                      type="text"
                      name="email"
                      placeholder="seu@email.com"
                      v-model="login.email"
                    />
                  </div>
                </div>

                <div class="input-wrapper">
                  <div class="label-header">
                    <label for="" class="lb-pass">Senha</label>
                  </div>
                  <div class="input-field">
                    <i><b-icon-lock-fill font-scale="1.3" /></i>
                    <input
                      type="password"
                      name="pass"
                      placeholder="Digite sua senha"
                      @keyup.enter="sendLogin"
                      v-model="login.password"
                    />
                  </div>
                </div>

                <button class="btn solid" @click="sendLogin">Entrar</button>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: center;
                  flex-direction: column;
                "
              >
                <p
                  class="recoverPassText"
                  @click="handleSectionsEnable('requestRecoveryPassword')"
                >
                  Esqueceu a senha ?
                </p>

                <p class="secure-text">Ambiente seguro e protegido</p>
              </div>
            </form>

            <form
              v-if="sectionsEnable.requestRecoveryPassword"
              action="#"
              class="sign-in-form"
              @submit.prevent
            >
              <div class="right-logo">
                <div class="content-logo">
                  <div class="fist-logo"></div>
                </div>
              </div>

              <div class="content-titles">
                <p class="title-right-section">Esqueceu sua senha ?</p>
                <p class="subtitle-right-section">
                  Sem problemas! Digite seu e-mail e enviaremos um link para
                  você criar uma nova senha.
                </p>
              </div>

              <div class="body-inputs">
                <div class="input-wrapper">
                  <label for="" class="lb-email">E-mail</label>
                  <div class="input-field">
                    <i><b-icon-envelope-fill font-scale="1.3" /></i>
                    <input
                      type="text"
                      name="email"
                      placeholder="seu@email.com"
                      v-model="emailToResetPassword"
                    />
                  </div>
                </div>

                <div class="reset-actions">
                  <button
                    class="btn solid"
                    @click="forgotMyPassword"
                    ref="emailToResetPassword"
                  >
                    Enviar link de recuperação
                  </button>

                  <p class="invalidMessage">{{ invalidMessage }}</p>

                  <div
                    class="back-to-login"
                    @click="handleSectionsEnable('login')"
                  >
                    <b-icon-arrow-left-short
                      scale="1.3"
                      style="color: #6a6a6a"
                    />
                    <p>Voltar ao login</p>
                  </div>

                  <div
                    v-if="spinResetPassword"
                    class="container-loading-reset-password"
                  >
                    <b-spinner class="spin-reset-password" />
                  </div>
                </div>
              </div>

              <p class="secure-text">Ambiente seguro e protegido</p>
            </form>
          </div>
        </div>
      </section>
    </div>

    <div v-if="sectionsEnable.forgotMyPassword" class="forms-containe">
      <ResetPassword />
    </div>

    <div
      v-if="
        loadingLogin &&
        !sectionsEnable.login &&
        !sectionsEnable.forgotMyPassword
      "
      class="forms-containe-progress"
    >
      <img style="width: 120px; height: 120px" :src="logoBms" />
      <div class="progress-container">
        <div class="progress-bar" :style="{ width: fakeProgress + '%' }"></div>
      </div>
      <p class="progressText">{{ fakeProgress }}%</p>
      <span class="loadingText"> Buscando Informações </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ResetPassword from "../ResetPassword/ResetPassword.vue";
import LoginService from "../../services/serviceLogin";
import ServiceMail from "../../services/serviceMail";
import { clearTokens } from "../../utils/clearTokens";
import { ValidateEmailResetPassword } from "../../validators/emailResetPassword";
import { HandleErrors } from "../../utils/handleErrors";
import api from "../../services/axios";
import moment from "moment";
import logoBms from "../../assets/gearSun.png";

export default {
  components: {
    ResetPassword,
  },
  data() {
    return {
      logoBms: logoBms,
      typeWaveAnimation: "",
      visibilitySaibaMais: "hideLogin",
      visibilityLogin: "showLogin",
      datainiciouso: moment().format("YYYY-MM-DD"),
      isCheck: false,
      isWarning: false,
      hourglass: true,
      infoNewClient: {},
      login: {
        email: "",
        password: "",
      },
      companyTotal: { companyCad: {}, companyLogger: {}, companyMail: {} },
      company: {
        nome: "",
        telefone: "",
        email: "",
        cpfcnpj: "",
        type: 1,
        companyName: "",
        datainiciouso: "",
        datafimuso: "",
      },
      logger: {
        nome: "",
        email: "",
        password: "",
      },
      email: {
        office: "",
        acting: "",
        employee: "",
      },
      sectionsEnable: {
        login: true,
        tester: false,
        forgotMyPassword: false,
        requestRecoveryPassword: false,
      },
      tipo: [
        { value: 1, text: "CPF" },
        { value: 2, text: "CNPJ" },
      ],
      cargo: [
        { value: "", text: "Selecione..." },
        { value: "Analista Contas a Pagar", text: "Analista Contas a Pagar" },
        {
          value: "Analista Contas a Receber",
          text: "Analista Contas a Receber",
        },
        { value: "Analista Faturamento", text: "Analista Faturamento" },
        { value: "Compras/Produção", text: "Compras/Produção" },
        { value: "Contabilidade/Fiscal", text: "Contabilidade/Fiscal" },
        {
          value: "Coordenador/Gerente Financeiro",
          text: "Coordenador/Gerente Financeiro",
        },
        { value: "Diretor Financeiro/CFO", text: "Diretor Financeiro/CFO" },
        { value: "Diretor/Sócio", text: "Diretor/Sócio" },
        { value: "Estagiário/Assistente", text: "Estagiário/Assistente" },
        { value: "TI", text: "TI" },
        { value: "Vendas/Comercial", text: "Vendas/Comercial" },
        { value: "Outros", text: "Outros" },
      ],
      ramo: [
        { value: "", text: "Selecione..." },
        { value: "Alimentação e Bebidas", text: "Alimentação e Bebidas" },
        { value: "Vestuário e calçados", text: "Vestuário e calçados" },
        { value: "Construção", text: "Construção" },
        { value: "Saúde", text: "Saúde" },
        { value: "Educação", text: "Educação" },
        { value: "Serviços pessoais", text: "Serviços pessoais" },
        { value: "Serviços especializados", text: "Serviços especializados" },
        { value: "Informática/Tecnologia", text: "Informática/Tecnologia" },
        { value: "Outro", text: "Outro" },
      ],
      funcionario: [
        { value: "", text: "Selecione..." },
        { value: "1 a 5", text: "De 1 a 5 funcionários" },
        { value: "6 até 15", text: "De 6 até 15 funcionários" },
        { value: "16", text: "Mais de 16 funcionários" },
      ],
      emailToResetPassword: "",
      spinResetPassword: false,
      invalidMessage: "",
      invalidinputEmailToResetPassword: "",
      open: true,
      loadingLogin: false,
      fakeProgress: 0,
    };
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    handleSectionsEnable(name) {
      this.sectionsEnable = {
        login: false,
        tester: false,
        forgotMyPassword: false,
        requestRecoveryPassword: false,
        [name]: true,
      };

      if (name !== "login") this.clearAllInputs();
    },
    async sendLogin() {
      if (this.login.email === "" || this.login.password === "") {
        return this.$toast.open({
          message: "O campo login e senha devem ser preenchidos",
          type: "info",
        });
      }

      this.sectionsEnable.login = false;
      this.loadingLogin = true;
      this.fakeProgress = 0;

      const interval = setInterval(() => {
        if (this.fakeProgress < 60) {
          this.fakeProgress += Math.floor(Math.random() * 5) + 1;
        } else if (this.fakeProgress >= 60 && this.fakeProgress < 75) {
          this.fakeProgress += 0.5;
        } else if (this.fakeProgress >= 75 && this.fakeProgress < 99) {
          this.fakeProgress += 1;
        }

        if (this.fakeProgress > 99) this.fakeProgress = 99;
      }, 200);

      try {
        const {
          token,
          permissions,
          tokens,
          userLevel,
          winfitCompleto,
          isTrackerUser,
        } = await LoginService.logar(this.login);

        localStorage.setItem("token", token);
        localStorage.setItem("permissions", JSON.stringify(permissions));
        localStorage.setItem("userLevel", userLevel);
        localStorage.setItem("isTrackerUser", isTrackerUser);
        localStorage.setItem("tokenList", JSON.stringify(tokens));
        localStorage.setItem("winfitCompleto", JSON.stringify(winfitCompleto));

        this.fakeProgress = 99;
        clearInterval(interval);

        await new Promise(resolve => setTimeout(resolve, 1000));
        this.fakeProgress = 99;
        await this.$router.push({ path: "/home" });
        window.location.reload()
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.fakeProgress = 100;
      } catch (error) {
        clearInterval(interval);
        this.fakeProgress = 0;
        this.loadingLogin = false;
        this.sectionsEnable.login = true;

        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Verifique se o login e senha estão corretos!";

        return this.$toast.open({
          message: message,
          type: "error",
        });
      } finally {
        clearInterval(interval);
      }
    },

    async sendMail() {
      await api.post("/mail/info/client", this.infoNewClient);
    },

    async forgotMyPassword() {
      try {
        const isValid = ValidateEmailResetPassword(this.emailToResetPassword);
        if (isValid) {
          return this.handleInputEmailToResetPassword();
        }

        this.spinResetPassword = true;

        await ServiceMail.confirmCode({ email: this.emailToResetPassword });

        this.handleSectionsEnable("login");
        this.emailToResetPassword = "";
        this.$toast.open({
          message: "Email encaminhado",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao enviar o email",
          type: "info",
        });
      } finally {
        this.spinResetPassword = false;
        this.loadingPassword = "";
      }
    },

    handleInputEmailToResetPassword() {
      this.$refs.emailToResetPassword.focus();
      this.invalidinputEmailToResetPassword =
        "invalidinputEmailToResetPassword";
      this.invalidMessage = "* Campo Email deve ser um email válido!";
    },

    clearInvalidInput() {
      this.invalidinputEmailToResetPassword = "";
      this.invalidMessage = "";
    },

    clearAllInputs() {
      this.company = {
        nome: "",
        telefone: "",
        email: "",
        cpfcnpj: "",
        type: 1,
        companyName: "",
        datainiciouso: "",
        datafimuso: "",
      };

      this.logger = {
        nome: "",
        email: "",
        password: "",
      };

      this.email = {
        office: "",
        acting: "",
        employee: "",
      };

      this.emailToResetPassword = "";
    },

    verifyExitsToken() {
      if (!this.getToken) {
        const token = localStorage.getItem("token");
        if (token) {
          return this.$router.push({
            path: "/home",
          });
        }

        clearTokens();
      }
    },

    assingValueCadCompany() {
      let currentDate = moment();
      let dateAfter30Days = currentDate.add(30, "days");
      let dateFormatted = dateAfter30Days.format("YYYY-MM-DD");
      this.logger.nome = this.company.nome;
      this.logger.email = this.company.email;
      this.company.datainiciouso = this.datainiciouso;
      this.company.datafimuso = dateFormatted;
      this.companyTotal.companyCad = this.company;
      this.companyTotal.companyLogger = this.logger;
      this.companyTotal.companyMail = this.email;
      this.infoNewClient = this.companyTotal;
    },

    async redirectAndLogger() {
      this.login.email = this.logger.email;
      this.login.password = this.logger.password;
      this.handleSectionsEnable("login");

      this.$bvModal.hide("modal-loader");
      await this.sendLogin();
    },

    async newCompany() {
      try {
        this.$bvModal.show("modal-loader");
        this.assingValueCadCompany();
        await this.sendMail();
        await api.post("/gestao/tester", this.companyTotal);
        this.isCheck = true;
        this.hourglass = false;
        this.redirectAndLogger();
      } catch (error) {
        this.hourglass = false;
        this.isCheck = false;
        this.isWarning = true;
        const typeError = HandleErrors(error?.response?.data?.message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao salvar o novo usuario",
          type: "info",
        });
      }
    },
  },
  computed: {
    ...mapState(["dataCompany"]),
    maskCelular() {
      return "(##) #####-####";
    },
    maskcpfcnpj() {
      if (!this.company.cpfcnpj) {
        return "";
      }

      if (this.company.cpfcnpj.length <= 14) {
        return "###.###.###-##";
      }

      if (this.company.cpfcnpj.length > 14) {
        return "##.###.###/####-##";
      } else {
        return "";
      }
    },

    getToken() {
      return this.$route.query.token;
    },
  },
  mounted() {
    this.verifyExitsToken();

    if (this.getToken) {
      this.handleSectionsEnable("forgotMyPassword");
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: monospace;
}

body,
input {
  font-family: monospace;
}

.container-custom {
  width: 100vw !important;
  height: 100vh !important;
  background-image: url("../../assets/fundo_verde.png");
  min-height: 100vh;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  display: flex;
}

.main-wrapper {
  width: 100%;
  display: flex;
  height: 100%;
}

.left-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 40px 40px 60px;
}

.content-left-section {
  max-width: 680px;
  max-height: 525px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.text-content-left {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.title-left-section {
  color: white;
  font-size: 1.7rem;
  font-weight: 600;
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.534));
}

.subtitle-left-section {
  font-family: Poppins-Regular, sans-serif !important;
  font-size: 0.9rem;
  line-height: 1.6;
  font-weight: 400;
  max-width: 540px;
  color: rgba(255, 255, 255, 0.887);
}

.beneficios {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.beneficio {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.85rem;
}

.beneficio svg {
  min-width: 30px;
  width: 30px;
  height: 30px;
  color: #f5a623;
  opacity: 0.95;
}

.beneficio span {
  font-family: Poppins-Regular, sans-serif !important;
  color: rgba(255, 255, 255, 0.78);
}

.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.forms-containe {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.signin-signup {
  width: 90%;
  max-width: 480px;
  background: white;
  border-radius: 10px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.464);
  z-index: 9999;
}

form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}

.title-right-section {
  font-size: 1.7rem;
  font-weight: 600;
  color: #0b7a68;
  text-align: center;
}

.subtitle-right-section {
  color: gray;
  font-size: 0.9rem;
  margin-top: 10px;
  font-weight: 400;
  font-family: Poppins-Regular, sans-serif !important;
  word-spacing: 2px;
  text-align: center;
}

.body-inputs {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  width: 100%;
}

.label-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 30px whitesmoke inset !important;
  box-shadow: 0 0 0 30px whitesmoke inset !important;
  height: 30px;
}

.lb-email,
.lb-pass {
  font-size: 14px;
  color: black;
  font-family: Poppins-Medium, sans-serif !important;
}

.recoverPassText {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
  color: #00786a;
  cursor: pointer;
  margin: 0;
}

.recoverPassText:hover {
  color: #006256;
}

.input-field {
  width: 100%;
  height: 48px;
  padding: 0 10px 0 0;
  border-radius: 10px;
  display: grid;
  grid-template-columns: 15% 85%;
  align-items: center;
  background: whitesmoke;
  box-shadow: 0 0 1px 1px rgb(195, 195, 195);
  transition: ease 0.1s;
}

.input-field i {
  text-align: center;
  color: #00786a;
  font-size: 14px;
}

.input-field input {
  background: transparent;
  outline: none;
  border: none;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  width: 100%;
}

.input-field:has(input:focus) {
  box-shadow: 0 0 1px 1.5px #00a651;
}

.btn {
  width: 100%;
  background-color: #00786a;
  border: none;
  height: 48px;
  border-radius: 10px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  cursor: pointer;
  transition: 0.3s;
  font-family: Poppins-Bold, sans-serif !important;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.464);
}

.btn:hover {
  background-color: #006256;
  color: #fff;
}

.secure-text {
  text-align: center;
  margin: 0;
  color: #5c665c;
  font-size: 12px;
  font-family: Poppins-Regular, sans-serif !important;
}

.reset-actions {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}

.back-to-login {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.back-to-login p {
  margin: 0;
  color: #6a6a6a;
  font-size: 0.85rem;
}

.content-logo {
  width: 100%;
  height: 50px;
  position: relative;
  z-index: 1;
}

.content-logo::before {
  content: "";
  position: absolute;
  top: -110px;
  left: 20%;
  transform: translate(-50%, -50%);
  width: 118vw;
  height: 700px !important;
  background: url("../../assets/sombra_branca1.png") no-repeat center center;
  background-size: contain;
  z-index: -1;
  pointer-events: none;

  -webkit-mask-image: radial-gradient(
    ellipse at center,
    black 40%,
    transparent 70%
  );
  mask-image: radial-gradient(ellipse at center, black 40%, transparent 70%);
}

.fist-logo {
  width: 200px;
  height: 100px;
  background: url("../../assets/logo_winfit.png") no-repeat left center;
  background-size: contain;
  /* filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.765))
    drop-shadow(0 10px 15px rgba(255, 255, 255, 0.765))
    drop-shadow(0 -10px 15px rgba(255, 255, 255, 0.765))
    drop-shadow(-10px 0 15px rgba(255, 255, 255, 0.765)); */
  position: absolute;
  top: -35px;
  left: -10px;
}

.right-logo {
  display: none;
}

.forms-containe-progress {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #293c3ad1;
  z-index: 50;
}

.progress-container {
  width: 200px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  margin: 8px 0;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #4caf50;
  transition: width 0.3s ease;
}

.progressText {
  font-size: 14px;
  color: white;
  margin: 0;
}

.loadingText {
  font-size: 12px;
  color: white;
}

.invalidMessage {
  color: red;
  font-size: 12px;
  margin: 0;
}

.invalidinputEmailToResetPassword {
  border: solid 1px red !important;
}

@media screen and (min-width: 1800px) {
  .fist-logo {
    width: 350px;
    height: 200px;
    top: -70px;
  }

  .content-left-section {
    max-width: none !important;
    height: 100% !important;
    max-height: 715px !important;
  }

  .title-left-section {
    font-size: 3rem;
  }

  .subtitle-left-section {
    font-size: 1.5rem;
    max-width: 640px;
  }

  .title-right-section {
    font-size: 2.5rem;
  }

  .subtitle-right-section {
    font-size: 1.2rem;
    margin-top: 2rem;
  }

  .signin-signup {
    max-width: 600px;
    padding: 4rem;
    width: 100%;
    height: 70%;
  }

  .sign-in-form {
    height: 100%;
    justify-content: space-between;
  }

  .text-content-left {
    gap: 4rem;
  }

  form {
    gap: 3rem;
  }

  .input-field {
    height: 60px;
  }

  .btn {
    height: 60px;
    font-size: 18px;
  }

  .beneficio svg {
    min-width: 40px;
    width: 40px;
    height: 40px;
    color: #f5a623;
    opacity: 0.95;
  }

  .beneficio {
    font-size: 1.3rem !important;
  }

  .body-inputs {
    gap: 2rem;
  }
}

@media screen and (max-width: 900px) {
  .left-section {
    display: none;
  }

  .right-section {
    width: 100%;
    flex: none;
    background-image: url("../../assets/fundo_verde.png");
    background-size: cover;
    background-position: center;
  }

  .signin-signup {
    padding: 2.5rem 1.5rem;
    width: 90%;
  }

  .right-logo {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .content-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 0;
  }

  .title-right-section {
    font-size: 1.5rem;
    text-align: center;
  }
  .subtitle-right-section {
    font-size: 0.9rem;
    text-align: center;
  }

  .fist-logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-position: center center;
  }
}

@media screen and (max-width: 450px) {
  .signin-signup {
    width: 100%;
    height: 100%;
    padding: 2rem 1rem;
  }

  form {
    gap: 1.5rem;
    height: 100%;
    justify-content: space-evenly;
  }
}

@media screen and (max-height: 600px) {
  .fist-logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-position: center center;
  }

  .text-content-left {
    gap: 1rem;
  }

  .title-left-section {
    font-size: 1.5rem;
  }

  .subtitle-left-section {
    font-size: 1rem;
  }

  .beneficios {
    gap: 0.5rem;
  }

  .beneficio svg {
    width: 20px;
    height: 20px;
    min-width: 20px;
  }

  .signin-signup {
    padding: 1.5rem;
  }

  form {
    gap: 1rem;
  }

  .title-right-section {
    font-size: 1.3rem;
  }

  .subtitle-right-section {
    font-size: 0.8rem;
    margin-top: 5px;
  }

  .body-inputs {
    gap: 0.8rem;
  }

  .input-field {
    height: 38px;
  }

  .input-field input {
    height: 28px;
    font-size: 12px;
  }

  .btn {
    height: 38px;
    margin-top: 5px;
  }

  .lb-email,
  .lb-pass {
    font-size: 12px;
  }
}
</style>
